import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import React, { useEffect } from 'react';
import { fetchEditableContact } from 'flow/actions/contact-actions';
import GenericSmallIconButton from 'flow/components/buttons/GenericSmallIconButton';
import ContactInfoFields from 'flow/components/contact-card/ContactInfoFields';
import ContactInfoFieldsFallback from 'flow/components/contact-card/ContactInfoFieldsFallback';
import ContactSettingsItems from 'flow/components/contact-card/ContactSettingsItems';
import { useModal } from 'flow/contexts/ModalProvider';
import useAppContext from 'flow/hooks/useAppContext';
import { useAppDispatch, useAppSelector } from 'flow/hooks/useRedux';
import { selectUserCountryCode } from 'flow/selectors/ExtensionSelectors';
import { isThirdPartyContactKey } from 'flow/utils';
import { selectEditableContactDTO } from 'flow/selectors/contact-selectors';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
var ContactInfoCard = function ContactInfoCard(_ref) {
  var contact = _ref.contact,
    extensionKey = _ref.extensionKey;
  var _useAppContext = useAppContext(),
    i18next = _useAppContext.i18next;
  var dispatch = useAppDispatch();
  var _useModal = useModal(),
    openModal = _useModal.openModal;
  var ownCountryCode = useAppSelector(selectUserCountryCode);
  var contactKey = contact === null || contact === void 0 ? void 0 : contact.get('key');
  var contactEditable = useAppSelector(function (state) {
    return selectEditableContactDTO(state, contactKey);
  });
  var contactEditableExists = !!contactEditable;
  useEffect(function () {
    if (contactEditableExists) return;
    void dispatch(fetchEditableContact(contactKey));
  }, [dispatch, contactKey, contactEditableExists]);
  var handleEditContact = function handleEditContact() {
    openModal('editContact', {
      contact: contact
    });
  };
  var handleCreateContact = function handleCreateContact() {
    openModal('createContact', {
      contact: contact,
      countryCode: ownCountryCode
    });
  };
  if (!contact) return null;
  var contactIsSaved = (contact === null || contact === void 0 ? void 0 : contact.has('key')) && !isThirdPartyContactKey(contact.get('key'));
  var contactInfoFieldsProps = {
    contact: contact,
    extensionKey: extensionKey
  };
  return /*#__PURE__*/_jsxs("div", {
    className: "bg-gray-150 w-full flex-1 rounded-sm p-1",
    children: [/*#__PURE__*/_jsxs("header", {
      className: "flex items-center justify-between py-5 ps-6 pe-4",
      children: [/*#__PURE__*/_jsx("div", {
        className: "text-2xl/5 font-bold text-gray-800",
        children: i18next.t('Settings.Account.Contact')
      }), contactIsSaved && contact.get('editable') && /*#__PURE__*/_jsx(GenericSmallIconButton, {
        onClick: handleEditContact,
        iconKey: "edit",
        label: i18next.t('Tooltip.Nav.Title.Edit'),
        className: "bg-transparent text-gray-500",
        size: "small"
      }), !contactIsSaved && /*#__PURE__*/_jsx(GenericSmallIconButton, {
        onClick: handleCreateContact,
        iconKey: "add",
        label: i18next.t('Colleagues.Create.External.Title'),
        className: "bg-white text-gray-400",
        size: "small"
      })]
    }), contactIsSaved && /*#__PURE__*/_jsx(ContactSettingsItems, {
      contact: contact,
      extensionKey: extensionKey
    }), contact.has('editableContactDTO') ? /*#__PURE__*/_jsx(ContactInfoFields, _objectSpread({}, contactInfoFieldsProps)) : /*#__PURE__*/_jsx(ContactInfoFieldsFallback, _objectSpread({}, contactInfoFieldsProps))]
  });
};
export default /*#__PURE__*/React.memo(ContactInfoCard);